import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button, ButtonPropsType } from 'components/Controls/Button';
import MoreHorizontalSvg from './moreHorizontal.svg';

interface IconButtonPropsType extends ButtonPropsType {
  iconSize?: number;
}

export const MoreHorizontalIcon = (props: any) => <Icon component={MoreHorizontalSvg} {...props} />;

export const MoreHorizontalIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonPropsType>(
  ({ size = 'medium', iconSize = 24, type = ButtonType.OutlineIcon, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<MoreHorizontalSvg width={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
MoreHorizontalIconButton.displayName = 'MoreHorizontalIconButton';
